import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EventService } from "src/app/services/event.service";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/services/auth.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EventEditComponent } from "../event-edit/event-edit.component";
import { EventSubscriptionlistComponent } from "../event-subscriptionlist/event-subscriptionlist/event-subscriptionlist.component";
import { EventTypeGroupInfoComponent } from "../event-type-group-info/event-type-group-info.component";
import { HttpEventType } from "@angular/common/http";

@Component({
  selector: "app-event-home",
  templateUrl: "./event-home.component.html",
  styleUrls: ["./event-home.component.scss"],
})
export class EventHomeComponent implements OnInit {
  event: any;
  permission: any = {
    hasCategory: false,
    hasAdmin: false,
    hasLive: false,
    hasInfo: false,
  };
  apiUrl: string;
  params: any = null;
  JSON: any = JSON;

  // File upload references
  @ViewChild('logoFileInput') logoFileInput: ElementRef;
  @ViewChild('coverFileInput') coverFileInput: ElementRef;
  @ViewChild('folderFileInput') folderFileInput: ElementRef;
  @ViewChild('ruleFileInput') ruleFileInput: ElementRef;
  @ViewChild('folderEditModal') folderEditModal: ElementRef;
  @ViewChild('ruleEditModal') ruleEditModal: ElementRef;

  // File upload properties
  logoKey: string = null;
  coverKey: string = null;
  folderKey: string = null;
  ruleKey: string = null;
  logoUrl: string = null;
  coverUrl: string = null;
  folderUrl: string = null;
  ruleUrl: string = null;
  
  // URLs completas para imagens
  folderImageUrl: string = null;
  ruleImageUrl: string = null;

  // Loading indicators
  loadingLogoUpload = false;
  loadingCoverUpload = false;
  loadingFolderUpload = false;
  loadingRuleUpload = false;

  // Upload progress
  logoPercentage = 0;
  coverPercentage = 0;
  folderPercentage = 0;
  rulePercentage = 0;

  constructor(
    private _event: EventService,
    private _auth: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal
  ) {}

  async ngOnInit() {
    this.apiUrl = environment.apiUrl;
    this.params = await this.route.params;
    this.initEventInfo();
  }

  async initEventInfo() {
    this.event = await this._event.getEvent(this.params.value.slug);
    this.event.coverUrl = JSON.stringify(this.event.coverUrl);
    this.permission = await this._event.getEventUserRoles(this.event._id);
  }

  // Modal methods
  openFolderEditModal() {
    this.modalService.open(this.folderEditModal, { size: 'lg' });
  }

  openRuleEditModal() {
    this.modalService.open(this.ruleEditModal, { size: 'lg' });
  }



  // File upload methods
  async onLogoSelected(event) {
    const target = event.target.files[0];
    const fd = new FormData();
    fd.append("file", target, target.name);

    // Passar o tipo 'logo' para o serviço
    this._event.uploadEventImage(fd, "logo").subscribe(
      (event: any) => {
        this.loadingLogoUpload = true;
        switch (event.type) {
          case HttpEventType.Sent:
            this.logoUrl = "Contatando o Servidor...";
            break;
          case HttpEventType.ResponseHeader:
            this.logoUrl = "Carregando...";
            break;
          case HttpEventType.UploadProgress:
            const percentDone = Math.round((100 * event.loaded) / event.total);
            this.logoPercentage = percentDone;
            break;
          case HttpEventType.Response:
            this.logoUrl = event.body.imageName;
            this.logoKey = event.body.imageKey;
            
            // Armazenar a URL completa para uso no updateEventLogo
            const imageUrl = event.body.imageUrl || event.body.fullUrl;
            
            // Chamar updateEventLogo com a URL completa
            this.updateEventLogo(imageUrl);
            this.loadingLogoUpload = false;
        }
      },
      (err) => {
        this.loadingLogoUpload = false;
        console.error('Logo upload error:', err);
      }
    );
  }

  async onCoverSelected(event) {
    const target = event.target.files[0];
    const fd = new FormData();
    fd.append("file", target, target.name);

    // Passar o tipo 'cover' para o serviço
    this._event.uploadEventImage(fd, "cover").subscribe(
      (event: any) => {
        this.loadingCoverUpload = true;
        switch (event.type) {
          case HttpEventType.Sent:
            this.coverUrl = "Contatando o Servidor...";
            break;
          case HttpEventType.ResponseHeader:
            this.coverUrl = "Carregando...";
            break;
          case HttpEventType.UploadProgress:
            const percentDone = Math.round((100 * event.loaded) / event.total);
            this.coverPercentage = percentDone;
            break;
          case HttpEventType.Response:
            this.coverUrl = event.body.imageName;
            this.coverKey = event.body.imageKey;
            
            // Armazenar a URL completa para uso no updateEventCover
            const imageUrl = event.body.imageUrl || event.body.fullUrl;
            
            // Chamar updateEventCover com a URL completa
            this.updateEventCover(imageUrl);
            this.loadingCoverUpload = false;
        }
      },
      (err) => {
        this.loadingCoverUpload = false;
        console.error('Cover upload error:', err);
      }
    );
  }

  async onFolderSelected(event) {
    const target = event.target.files[0];
    const fd = new FormData();
    fd.append("file", target, target.name);

    // Passar o tipo 'folder' para o serviço
    this._event.uploadEventImage(fd, "folder").subscribe(
      (event: any) => {
        this.loadingFolderUpload = true;
        switch (event.type) {
          case HttpEventType.Sent:
            this.folderUrl = "Contatando o Servidor...";
            break;
          case HttpEventType.ResponseHeader:
            this.folderUrl = "Carregando...";
            break;
          case HttpEventType.UploadProgress:
            const percentDone = Math.round((100 * event.loaded) / event.total);
            this.folderPercentage = percentDone;
            break;
          case HttpEventType.Response:
            this.folderUrl = event.body.imageName;
            this.folderKey = event.body.imageKey;
            
            // Armazenar a URL completa para uso posterior
            this.folderImageUrl = event.body.imageUrl || event.body.fullUrl;
            
            // Don't update yet, wait for user to click save in modal
            this.loadingFolderUpload = false;
        }
      },
      (err) => {
        this.loadingFolderUpload = false;
        console.error('Folder upload error:', err);
      }
    );
  }

  async onRuleSelected(event) {
    const target = event.target.files[0];
    const fd = new FormData();
    fd.append("file", target, target.name);

    // Passar o tipo 'rule' para o serviço
    this._event.uploadEventImage(fd, "rule").subscribe(
      (event: any) => {
        this.loadingRuleUpload = true;
        switch (event.type) {
          case HttpEventType.Sent:
            this.ruleUrl = "Contatando o Servidor...";
            break;
          case HttpEventType.ResponseHeader:
            this.ruleUrl = "Carregando...";
            break;
          case HttpEventType.UploadProgress:
            const percentDone = Math.round((100 * event.loaded) / event.total);
            this.rulePercentage = percentDone;
            break;
          case HttpEventType.Response:
            this.ruleUrl = event.body.imageName;
            this.ruleKey = event.body.imageKey;
            
            // Armazenar a URL completa para uso posterior
            this.ruleImageUrl = event.body.imageUrl || event.body.fullUrl;
            
            // Don't update yet, wait for user to click save in modal
            this.loadingRuleUpload = false;
        }
      },
      (err) => {
        this.loadingRuleUpload = false;
        console.error('Rule upload error:', err);
      }
    );
  }

  // Update event methods
  /**
   * Atualiza o logo do evento
   * @param imageUrl URL completa da imagem (opcional)
   */
  updateEventLogo(imageUrl?: string) {
    // Se não foi fornecida uma URL, tentar usar a URL existente no evento
    if (!imageUrl && this.event.logoUrl && this.event.logoUrl.startsWith('http')) {
      imageUrl = this.event.logoUrl;
    }
    
    // Usar a URL completa se disponível, caso contrário usar a chave
    this.updateEventImage('logo', this.logoKey, imageUrl);
  }

  /**
   * Atualiza a imagem de capa do evento
   * @param imageUrl URL completa da imagem (opcional)
   */
  updateEventCover(imageUrl?: string) {
    // Se não foi fornecida uma URL, tentar usar a URL existente no evento
    if (!imageUrl && this.event.coverUrl && this.event.coverUrl.startsWith('http')) {
      imageUrl = this.event.coverUrl;
    }
    
    // Usar a URL completa se disponível, caso contrário usar a chave
    this.updateEventImage('cover', this.coverKey, imageUrl);
  }

  /**
   * Atualiza uma imagem de evento no servidor
   * @param type Tipo de imagem ('logo', 'cover', 'folder' ou 'rule')
   * @param imageKey Chave da imagem
   * @param imageUrl URL completa da imagem (opcional)
   * @param closeModal Se deve fechar o modal após a atualização (padrão: false)
   */
  private updateEventImage(type: 'logo' | 'cover' | 'folder' | 'rule', imageKey: string, imageUrl?: string, closeModal: boolean = false) {
    if (!imageKey) return;

    // Configurar variáveis com base no tipo
    const fieldName = `${type}Url`;
    const loadingVar = `loading${type.charAt(0).toUpperCase() + type.slice(1)}Upload`;
    
    // Verificar se a imageKey já é uma URL completa
    const isKeyUrl = imageKey && (imageKey.startsWith('http://') || imageKey.startsWith('https://'));
    
    // Usar URL completa se disponível, caso contrário usar a chave
    // Se imageKey já é uma URL completa, usá-la diretamente
    const value = imageUrl || (isKeyUrl ? imageKey : `https://cloud.horsecs.com.br/${imageKey}`);
    
    // Log para depuração
    console.log(`Atualizando ${type}:`, {
      imageKey,
      imageUrl,
      valorFinal: value
    });
    
    const eventUpdate = { [fieldName]: value };
    
    this._event.updateEventImages(this.event._id, eventUpdate).then(
      (updatedEvent: any) => {
        this[loadingVar] = false;
        this.event[fieldName] = updatedEvent[fieldName];
        if (closeModal) {
          this.modalService.dismissAll();
        }
        this.initEventInfo();
      }
    ).catch(error => {
      this[loadingVar] = false;
      console.error(`${type} update error:`, error);
    });
  }

  updateEventFolder() {
    this.updateEventImage('folder', this.folderKey, this.folderImageUrl, true);
  }

  updateEventRule() {
    this.updateEventImage('rule', this.ruleKey, this.ruleImageUrl, true);
  }

  hasUsagePermission() {}

  openTab(tab) {
    this.router.navigate([`event/${this.params.value.slug}/${tab}`]);
  }

  getTab() {
    return this.params.value.tab;
  }

  goToLive() {
    if (this.permission.hasLive)
      this.router.navigate([`event/${this.params.value.slug}/live`]);
  }

  open() {
    const modalEdit = this.modalService.open(EventEditComponent);
    modalEdit.componentInstance.event = this.event;
    modalEdit.result.then((result) => {
      if (result == "updated") this.initEventInfo();
    });
  }

  openActiveSubscriptionlist() {
    const modalEdit = this.modalService.open(EventSubscriptionlistComponent);
    modalEdit.componentInstance.event = this.event;
  }

  openTypeGroup() {
    const modalTypeGroup = this.modalService.open(EventTypeGroupInfoComponent);
    modalTypeGroup.componentInstance.event = this.event;
  }
}
